module.exports = __webpack_public_path__ + "static/media/_MIC2480.thumbnail.8aa73ab0.png";